import React from 'react'
import Modal from '../Modal'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Button from '../Button'
import ErrorMessage from '../ErrorMessage'
import Spinner from '../Spinner'

function ConfirmModal({
  isOpen,
  closeModal,
  title,
  subTitle,
  className,
  primaryButtonText,
  secondatyButtonText,
  hasTitleHTML = false,
  handlePrimaryButton,
  handleSecondaryButton,
  error,
  titleCSS,
  loading,
  ...rest
}) {
  const { t } = useTranslation()
  primaryButtonText = primaryButtonText || t('global.yes')
  secondatyButtonText = secondatyButtonText || t('global.no')
  return (
    <Modal
      className={className}
      isOpen={isOpen}
      handleClose={closeModal}
      title={
        hasTitleHTML ? (
          <span
            className={styles.modalTitleWithHTML}
            dangerouslySetInnerHTML={{
              __html: title
            }}
          />
        ) : (
          title
        )
      }
      subTitle={subTitle}
      titleCSS={`${styles.modalTitle} ${titleCSS}`}
      {...rest}>
      <div className={styles.buttons}>
        <Button style='secondary' size='large' text={secondatyButtonText} handleClick={handleSecondaryButton} />
        <Button disabled={loading} text={primaryButtonText} size='large' handleClick={handlePrimaryButton} />
      </div>
      {error && <ErrorMessage text={error} />}
      {loading && <Spinner />}
    </Modal>
  )
}

export default ConfirmModal
